export default "__VITE_ASSET__cf654ef1__"